import { Typography } from '@material-ui/core';
import React, { ReactNode } from 'react';
import Spacing from '../../portico/spacing/spacing';
import { SvbStepper } from '../stepper';
import { useWelcomeBodyWrapper } from './welcome-body-wrapper.style';

interface WelcomeBodyWrapperProps {
  children?: any;
  activeStep: number;
  totalSteps: number;
  title: string;
  subTitle: string | ReactNode;
}

export const WelcomeBodyWrapper: React.FC<WelcomeBodyWrapperProps> = ({ children, ...props }) => {
  const {
    activeStep,
    totalSteps,
    title,
    subTitle
  } = props;

  const classes = useWelcomeBodyWrapper();

  return (
    <>
      <div>
        <SvbStepper activeStep={activeStep} totalSteps={totalSteps} />
        <Spacing variable="spacing-base-x2" />
        <Typography variant="h2" className={classes.fontBold}>{title}</Typography>
        <Spacing variable="spacing-base-x2" />
        <Typography variant="body1">{subTitle}</Typography>
        <Spacing variable="spacing-base-x2" />
      </div>
      <div className="welcome__wrapper__main">
        {children}
      </div>
    </>
  );
};
